/** Agentic AI domain sub-options */
export const AGENTIC_AI_DOMAINS = [
  { id: "financial", slug: "financial-domain", label: "Financial Domain", live: true },
  { id: "manufacturing", slug: "manufacturing", label: "Manufacturing", live: true },
  { id: "hr", slug: "hr-domain", label: "HR Domain", live: true },
  { id: "bfsi", slug: "bfsi-domain", label: "BFSI", live: true },
  { id: "healthcare", slug: "healthcare-domain", label: "Healthcare", live: true },
  { id: "logistics", slug: "logistics-domain", label: "Logistics", live: true },
  { id: "retail", slug: "retail-domain", label: "Retail", live: true },
  { id: "insurance", slug: "insurance-domain", label: "Insurance", live: true },
  { id: "telecom", slug: "telecom-domain", label: "Telecom", live: true },
  { id: "public-sector", slug: "public-sector-domain", label: "Public Sector & Government", live: true },
  { id: "real-estate", slug: "real-estate-domain", label: "Real Estate & Construction", live: true },
  { id: "hospitality", slug: "hospitality-domain", label: "Hospitality & Travel", live: true },
  { id: "agriculture", slug: "agriculture-domain", label: "Agriculture & Food Processing", live: true },
  { id: "it-services", slug: "it-services-domain", label: "IT & Technology Services", live: true },
  { id: "aviation", slug: "aviation-domain", label: "Aviation & Aerospace", live: true },
  { id: "automotive", slug: "automotive-domain", label: "Automotive", live: true },
  { id: "pharma", slug: "pharma-domain", label: "Pharma", live: true },
  { id: "media", slug: "media-domain", label: "Media & Entertainment", live: true },
  { id: "energy", slug: "energy-domain", label: "Energy & Utilities", live: true },
  { id: "education", slug: "education-domain", label: "Education", live: true },
];

/** High-impact enterprise use cases (capabilities page cards) */
export const AGENTIC_AI_ENTERPRISE_USE_CASES = [
  {
    id: "copilots",
    label: "AI Copilots for Enterprise Teams",
    scrollTo: "usecase-copilots",
    text: "Internal assistants for HR, IT, finance, procurement, operations, and customer support with secure knowledge access and guided actions.",
  },
  {
    id: "document-intelligence",
    label: "Document Intelligence Agents",
    scrollTo: "usecase-document-intelligence",
    text: "Agents that read, classify, extract, validate, summarize, and route invoices, contracts, policies, SOPs, claims, and compliance documents.",
  },
  {
    id: "process-automation",
    label: "Process Automation Agents",
    scrollTo: "usecase-process-automation",
    text: "AI-driven workflows for ticket triage, report generation, case management, approvals, vendor coordination, and exception handling.",
  },
  {
    id: "manufacturing-industry",
    label: "Manufacturing & Industry 4.0 Agents",
    scrollTo: "usecase-manufacturing-industry",
    text: "Operator guidance, maintenance copilots, quality review assistants, knowledge search, and workflow automation for plant and enterprise teams.",
  },
  {
    id: "sales-service",
    label: "Sales, Service & Customer Operations",
    scrollTo: "usecase-sales-service",
    text: "Proposal support, customer response drafting, knowledge-grounded support workflows, and account research orchestration.",
  },
  {
    id: "multi-agent",
    label: "Multi-Agent Decision Workflows",
    scrollTo: "usecase-multi-agent",
    text: "Coordinated specialist agents for analysis, validation, recommendation, and execution with human approval checkpoints.",
  },
];

export const AGENTIC_AI_CAPABILITIES_MENU = [
  { label: "Capabilities", scrollTo: "capabilities" },
  { label: "How We Engage", scrollTo: "engage" },
  { label: "Get Started", scrollTo: "contact" },
];

export const AGENTIC_AI_USE_CASES_LABEL = "Agentic Use Cases";

export const AGENTIC_AI_DROPDOWN = [
  ...AGENTIC_AI_CAPABILITIES_MENU.map((item) => item.label),
  AGENTIC_AI_USE_CASES_LABEL,
  ...AGENTIC_AI_DOMAINS.map((d) => d.label),
];

export const domainIdFromLabel = (label) =>
  AGENTIC_AI_DOMAINS.find((d) => d.label === label)?.id || "financial";

export const domainPathFromLabel = (label) => {
  const domain = AGENTIC_AI_DOMAINS.find((d) => d.label === label);
  return domain ? `/agentic-ai/${domain.slug}` : "/agentic-ai";
};

export const capabilitiesScrollFromLabel = (label) =>
  AGENTIC_AI_CAPABILITIES_MENU.find((item) => item.label === label)?.scrollTo;

export const isAgenticDomainLabel = (label) =>
  AGENTIC_AI_DOMAINS.some((d) => d.label === label);

export const enterpriseUseCaseScrollFromLabel = (label) =>
  AGENTIC_AI_ENTERPRISE_USE_CASES.find((item) => item.label === label)?.scrollTo;

export const capabilitiesPathFromLabel = (label) => {
  const scrollTo = capabilitiesScrollFromLabel(label);
  if (scrollTo) return `/agentic-ai#${scrollTo}`;
  const enterpriseScroll = enterpriseUseCaseScrollFromLabel(label);
  if (enterpriseScroll) return `/agentic-ai#${enterpriseScroll}`;
  return "/agentic-ai";
};

export const isEnterpriseUseCaseLabel = (label) =>
  AGENTIC_AI_ENTERPRISE_USE_CASES.some((item) => item.label === label);

